import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogoMark } from "../components/Logo";
import { Loader2, UserPlus } from "lucide-react";

const RegisterPage = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    setBusy(true);
    try {
      await register(name, email, password);
      navigate("/first-season-artist-info", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || "Unable to create account. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-5 relative overflow-hidden">
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 15% 20%, rgba(179,92,255,0.35), transparent 32%), radial-gradient(circle at 85% 15%, rgba(140,255,0,0.16), transparent 28%), #050005" }} />
      <div className="relative z-10 w-full max-w-md">
        <Link to="/first-season-artist-info" className="flex justify-center mb-8"><LogoMark className="w-52" /></Link>
        <div className="hss-card p-8">
          <h1 className="font-ui font-extrabold uppercase text-white text-2xl">Create your account</h1>
          <p className="text-white/50 text-sm mt-1 mb-6">Join First Season and share your story with HSS Feed.</p>
          {error && <div className="mb-4 rounded-xl border border-red-400/40 bg-red-500/10 px-4 py-2.5 text-sm text-red-300">{error}</div>}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="font-ui font-semibold text-white text-sm block mb-2">Name</label>
              <input type="text" required value={name} onChange={(e) => setName(e.target.value)} className="hss-input" placeholder="Your name" />
            </div>
            <div>
              <label className="font-ui font-semibold text-white text-sm block mb-2">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="hss-input" placeholder="you@example.com" />
            </div>
            <div>
              <label className="font-ui font-semibold text-white text-sm block mb-2">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="hss-input" placeholder="At least 8 characters" />
            </div>
            <button type="submit" disabled={busy} className="btn-green w-full justify-center mt-2">
              {busy ? <Loader2 className="animate-spin" size={17} /> : <UserPlus size={17} />} Create Account
            </button>
          </form>
          <p className="text-white/50 text-sm mt-6 text-center">
            Already have an account? <Link to="/login" className="font-semibold" style={{ color: "#8cff00" }}>Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
